import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { ExchangeShippingNameState } from "@redotech/redo-return-ui/flows/return-flow/exchange-shipping-name";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ExchangeShippingNameDetails = memo(
  function ExchangeShippingNameDetails({
    stepSelect,
    state,
    setState,
  }: StepTypeDetailsProps<ExchangeShippingNameState>) {
    const canEditReturnsSettings = useHasPermission(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    );
    const nextStepChange = useHandler((next: StepId | undefined) => {
      setState((state) => ({ ...state, next }));
    });
    const handleShippingNameChange = useHandler((shippingName: string) => {
      setState((state) => ({ ...state, shippingName }));
    });

    return (
      <>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Outgoing shipping line name
          </Text>
          <RedoTextInput
            placeholder="Enter shipping line name..."
            setValue={handleShippingNameChange}
            state={canEditReturnsSettings ? "default" : "readonly"}
            value={state.shippingName}
          />
          <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
            Name of the shipping line for outgoing exchange orders
          </Text>
        </Flex>
        <Flex dir="column" gap="xs">
          <Text fontSize="xs" fontWeight="medium" textColor="secondary">
            Next step
          </Text>
          {stepSelect({ value: state.next, valueChange: nextStepChange })}
        </Flex>
      </>
    );
  },
);
